// extracted by mini-css-extract-plugin
export var card = "collection-card-module--card--b8cd6";
export var image = "collection-card-module--image--36e86";
export var stats = "collection-card-module--stats--3b458";
export var title = "collection-card-module--title--1c45b";